/**
 * double-ended queue
 */
export class Deque<T> {
  private items: T[] = [];

  constructor(items: T[] = []) {
    this.items = [...items];
  }

  public init(item: T): this;
  public init(items: T[]): this;
  public init(data: T | T[]): this {
    this.clear();
    const items: T[] = Array.isArray(data) ? data : [data];
    this.items = [...items];
    return this;
  }

  /** 뒤쪽에 요소 추가 (enqueue) */
  public push(item: T): void {
    this.items.push(item);
  }

  /** 앞쪽에 요소 추가 (enqueue front) */
  public unshift(item: T): void {
    this.items.unshift(item);
  }

  /** 뒤쪽 요소 제거 및 반환 (dequeue back) */
  public pop(): T | undefined {
    return this.items.pop();
  }

  /** 앞쪽 요소 제거 및 반환 (dequeue front) */
  public shift(): T | undefined {
    return this.items.shift();
  }

  /** 앞쪽 요소 조회 (삭제하지 않음) */
  public peekFront(): T | undefined {
    return this.items[0];
  }

  /** 뒤쪽 요소 조회 (삭제하지 않음) */
  public peekBack(): T | undefined {
    return this.items[this.items.length - 1];
  }

  /** 내부 배열을 복사해서 반환 */
  public toArray(): T[] {
    return [...this.items];
  }

  /** 모든 요소 제거 */
  public clear(): void {
    this.items.length = 0;
  }

  /** 현재 요소 개수 반환 */
  public get size(): number {
    return this.items.length;
  }

  /**
   * 조건에 맞는 첫 번째 요소 삭제
   * @returns 삭제 성공 여부
   */
  public delete(predicate: (item: T) => boolean): T | undefined {
    const index = this.items.findIndex(predicate);
    if (index >= 0) {
      const [deleted] = this.items.splice(index, 1);
      return deleted;
    }
    return undefined;
  }

  /**
   * 조건을 만족하는 요소가 존재하는지 확인
   * @returns 존재 여부
   */
  public has(predicate: (item: T) => boolean): boolean {
    return this.items.some(predicate);
  }
}
